module.exports = __webpack_public_path__ + "static/media/sandy-millar-1474214-unsplash.655e7a4e.jpg";